import type { PropsWithChildren, ReactNode } from 'react'
import { twMerge } from 'tailwind-merge'

export function HeaderShell(props: Readonly<PropsWithChildren<{ translateChild?: ReactNode }>>) {
  return (
    <>
      <div className="flex items-center justify-center relative bg-white">
        <header className="h-16 md:h-28 container flex items-center justify-between px-4 md:px-0">
          {props.children}
        </header>
      </div>

      {props.translateChild}
    </>
  )
}

export function FooterShell(props: PropsWithChildren<{ className?: string }>) {
  return (
    <>
      <div className="flex items-center justify-center bg-bgLavender">
        <footer className={twMerge(
          'text-white container py-10 flex flex-col md:flex-row items-center md:items-start justify-between',
          props.className,
        )}
        >
          {props.children}
        </footer>
      </div>

      <div className="bg-bgLavenderDark text-center text-white py-10">
        &copy; Copyright &nbsp;
        {new Date().getFullYear()}
&nbsp; - CAHO - All Rights Reserved
      </div>
    </>
  )
}
